(() => {
  'use strict';
  const bar=document.querySelector('[data-nd-return]');
  if(!bar)return;
  const link=bar.querySelector('[data-nd-return-link]');
  const label=bar.querySelector('[data-nd-return-label]');
  let previous=null;
  try{
    const ref=new URL(document.referrer);
    if(ref.origin===location.origin && ref.pathname+ref.search!==location.pathname+location.search)previous=ref;
  }catch(_){}
  function refresh(){
    link.href=previous?previous.href:bar.dataset.home;
    label.textContent=previous?bar.dataset.backLabel:bar.dataset.homeLabel;
    bar.hidden=!previous&&bar.dataset.isHome==='true';
  }
  link.addEventListener('click',event=>{
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(previous&&history.length>1){event.preventDefault();history.back();}
  });
  window.addEventListener('pageshow',refresh);
  refresh();
})();
